import React from 'react';
import MarketingHeader from './MarketingHeader';
import CStepper from '../Common/Header/CStepper';
import '../Steps.css';

/** V1 Design My Life Blueprint shell — stepper + header (marketing only). */
const MarketingStepsShell = ({ activeStep = 0, children, className = '' }) => (
    <div
        className={`marketing-v1-shell marketing-steps-shell Dashboard__container ${className}`.trim()}
    >
        <MarketingHeader />
        <CStepper indexStep={activeStep} mobile={false} />
        <div className="marketing-steps-shell__body">{children}</div>
    </div>
);

export default MarketingStepsShell;
